import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const ModalAlert = ({
  show,
  onClose,
  title = 'Alert',
  message = 'Something happened.',
  icon = 'bi-exclamation-triangle-fill',
  iconColor = 'text-danger',
}) => {
  useEffect(() => {
    if (show) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [show]);

  if (!show) return null;

  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      role="dialog"
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1050,
      }}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
          </div>
          <div className="modal-body d-flex align-items-center gap-3">
            <div className={`${iconColor} fs-3`}>
              <i className={`${icon}`} />
            </div>
            <div>
              <p className="mb-0">
                <strong>Error:</strong> {message}
              </p>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

ModalAlert.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default ModalAlert;
